import React from 'react';
import IdsPlayer from "../../Clienti/ids_player";

const FormIDSMaestro = (props) => {

    // Adatta i dati del maestro (idsGuru) alla forma attesa da IdsPlayer (idsPlay),
    // così la schermata IDS del maestro è identica a quella del player.
    // Il telefono del maestro è sotto professionalContacts, lo riportiamo a phoneNumber.
    const mappedProfile = (props.profile && props.profile.idsGuru)
        ? {
            ...props.profile,
            idsPlay: {
                ...props.profile.idsGuru,
                phoneNumber: (props.profile.idsGuru.professionalContacts && props.profile.idsGuru.professionalContacts.phoneNumber)
                    ? props.profile.idsGuru.professionalContacts.phoneNumber
                    : (props.profile.idsGuru.phoneNumber || '')
            }
        }
        : props.profile;

    return (
        <IdsPlayer
            isDisabled={props.isDisabled}
            profile={mappedProfile}
            privateProfile={props.privateProfile}
        />
    );
}

export default FormIDSMaestro
